import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlatformService } from '@pxl/models/contracts';
import { AppRoutingRouteNames } from '@pxl/route-names';

/**
 * Blocks routes that only make sense inside the native app (e.g. the app update info page) and
 * sends browser users to the dashboard instead.
 */
export const nativeOnlyGuard: CanActivateFn = () => {
    const platformService = inject(PlatformService);
    const router = inject(Router);

    return platformService.isNativePlatform() ? true : router.createUrlTree([AppRoutingRouteNames.Dashboard]);
};
